import { EsignApiBase } from './base';

export class HelloSignApi extends EsignApiBase {
  async getHelloSignSettings() {
    return super.get(`hellosign-settings/`, `Could not retrieve HelloSign settings`);
  }
}
